export default __webpack_public_path__ + "static/media/5.5721e80e.jpg";